import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdControleEstoque: number;
  DescricaoPesquisa: string;
  centroDeCusto: number[];
  centroDeCustoLista: CentroCustoDropDown[] | undefined;
}

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setDescricaoPesquisa: SetFunction<string>;
  setCentroDeCusto: SetFunction<number[]>;
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>;
};

export const initialFiltersValues: State = {
  IdControleEstoque: 0,
  DescricaoPesquisa: "",
  centroDeCusto: [],
  centroDeCustoLista: undefined,

};

export const useControleEstoqueFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setDescricaoPesquisa: (vfn) => SetFunctionImpl(set, 'DescricaoPesquisa', vfn),
  setCentroDeCusto: (vfn) => SetFunctionImpl(set, 'centroDeCusto', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
    centroDeCustoLista: state.centroDeCustoLista
  })),
}));